export default __webpack_public_path__ + "static/media/laravel.8b2939ca.png";